import { Box, Typography } from '@mui/material';

const DateComponent = ({
  formattedDates,
}: {
  formattedDates: Array<{ dayName: string; dateNumber: number }>;
}) => (
  <>
    {formattedDates?.map(({ dayName, dateNumber }, index) => (
      <Box
        key={index}
        bgcolor={
          Math.ceil(formattedDates.length / 2) === index + 1
            ? 'common.white'
            : 'transparent'
        }
        gap={0.75}
        px={2.5}
        py={1.5}
        borderRadius={3}
        maxWidth="80px"
        className="d-flex flex-column justify-content-center align-items-center flex-1"
      >
        <Typography
          variant="body1"
          color={
            Math.ceil(formattedDates.length / 2) === index + 1
              ? 'secondary.main'
              : 'common.white'
          }
        >
          {dayName}
        </Typography>
        <Typography
          variant="h5"
          color={
            Math.ceil(formattedDates.length / 2) === index + 1
              ? 'secondary.main'
              : 'common.white'
          }
        >
          {dateNumber}
        </Typography>
      </Box>
    ))}
  </>
);

export default DateComponent;
